import React from "react";
import { CollaboratorDetails } from "./CollaboratorDetails";

const MyAccountCollabDetails = () => {
  return (
    <div className="ltn__myaccount-tab-content-inner">
      <CollaboratorDetails />
    </div>
  );
};
export default MyAccountCollabDetails;
